import { Button, styled } from "@mui/material";

export const SquareButton = styled(Button)(({theme}) => ({
  padding: 0,
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  minWidth: 0,
  borderRadius: 0,
}))